/* eslint-disable */

export enum StatementType {
  ACCOUNT_GENERAL_STATEMENT = "ACCOUNT_GENERAL_STATEMENT",
  SAVINGS_STATEMENT = "SAVINGS_STATEMENT",
}

export interface StatementTypeDetails {
  customer_token?: string;
  statement_type?: StatementType;
  is_sponsored_account?: boolean;
  display_name?: string;
  is_active_sponsored_account?: boolean;
}
